import { Supplier } from "./../../../models/supplier";
import { Observable } from "rxjs";
import { SubscriptionFilterChangedEvent } from "./../../../models/subscription-filter-changed-event";
import { CreateSubscriptionFilterComponent } from "./../../../models/create-subscription-filter-component";
import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { selectSupplierOptions } from "../../../store/data-exchange.selectors";
import { DestroyableDirective } from "@app/abstract/destroyable";
import { SubscriptionFilter } from "../../../models/subscription-filter";
import { SubscriptionFilterKey } from "../../../models/enum/subscription-filter-key";
import { takeUntil } from "rxjs/operators";
import * as DistributionCenterSelectors from "@app/shared/state/distribution-center/distribution-center.selectors";
import { DistributionCenter } from "@app/distribution-center/distribution-center";

@Component({
    selector: "app-inventory-stock-status-filter",
    templateUrl: "./inventory-stock-status-filter.component.html",
    styleUrls: [],
    standalone: false
})
export class InventoryStockStatusFilterComponent
  extends DestroyableDirective
  implements OnInit, CreateSubscriptionFilterComponent
{
  dcOptions: DistributionCenter[];
  supplierOptions$: Observable<Supplier[]>;

  selectedSupplier: Supplier = null;
  selectedDcList: DistributionCenter[] = [];

  @Output()
  filterChanged = new EventEmitter<SubscriptionFilterChangedEvent>();

  constructor(private _store: Store) {
    super();
  }

  ngOnInit() {
    this._store
      .pipe(
        takeUntil(this.destroy$),
        select(
          DistributionCenterSelectors.selectDistributionCenterListWithTrimmedName,
        ),
      )
      .subscribe((dcs) => {
        this.dcOptions = dcs;
      });

    this.supplierOptions$ = this._store.pipe(select(selectSupplierOptions));
  }

  reset() {
    this.selectedDcList = [];
    this.selectedSupplier = null;
    this.publishFilterChangedEvent();
  }

  onSupplierSelected() {
    this.publishFilterChangedEvent();
  }

  onDcSelected() {
    this.publishFilterChangedEvent();
  }

  selectAllDcs(): void {
    if (this.selectedDcList.length === this.dcOptions.length) {
      return;
    }
    this.selectedDcList = this.dcOptions;
    this.onDcSelected();
  }

  isFormValid(): boolean {
    return (
      !!this.selectedDcList &&
      this.selectedDcList.length > 0 &&
      !!this.selectedSupplier
    );
  }

  getFilters(): SubscriptionFilter[] {
    return [
      {
        key: SubscriptionFilterKey.Dc,
        value: this.selectedDcList.map((dc) => dc.number),
      },
    ];
  }

  publishFilterChangedEvent(): void {
    const formValid = this.isFormValid();

    this.filterChanged.emit({
      filtersValid: formValid,
      selectedSupplier: this.selectedSupplier,
      filters: formValid ? this.getFilters() : [],
    });
  }

  tagMapper(tags: any[]): any[] {
    return tags.length < 3 ? tags : [tags];
  }
}
